import React, { useState } from "react";
import classNames from "classnames";

const ReactPrimaryButton = ({
  className, // additional classname utilized by outer div
  onClick,
  onMouseOver,
  onMouseOut,
  onKeyDown,
  onKeyUp,
  onBlur,
  colorScheme = "dark",
  outlined = false,
  disabled,
  chevron, // "left or right" (not implemented)
  buttonProps, // props to set on the button contained in the div
  children, // default property passed by React
  dataTestId = "",
  ...rest // any additional props to set on the outer div, such as data-testid
}) => {
  const classes = {
    COMPONENT: "js-fds-primary-button",
    BUTTON: "fds-primary-button__button",
    HOVER: "fds-primary-button--hover",
    ACTIVE: "fds-primary-button--active",
    FOCUSED: "fds-primary-button--focused",
    DISABLED: "fds-primary-button--disabled",
    TOUCH: "fds-primary-button--touch",
    OUTLINED: "fds-primary-button--outlined",
    ICON: "fds-icon",
    ICON_WRAPPER: "fds-primary-button__icon-wrapper",
    ICON_CHEVRON_PATH1: "fds-primary-button__chevron-filled-right-path1",
    ICON_CHEVRON_PATH2: "fds-primary-button__chevron-filled-right-path2",
    COLOR_SCHEME: `fds-color__bg--${colorScheme}`,
  };

  const [state, setState] = useState({
    displayHover: false,
    displayActive: false,
    displayFocused: false,
  });

  const onMouseOverWrapper = () => {
    if (!disabled) {
      setState((prevState) => {
        return { ...prevState, displayHover: true };
      });
      if (onMouseOver) {
        onMouseOver();
      }
    }
  };

  const onMouseOutWrapper = () => {
    if (!disabled) {
      setState((prevState) => {
        return { ...prevState, displayHover: false };
      });
      if (onMouseOut) {
        onMouseOut();
      }
    }
  };

  const onClickWrapper = (e) => {
    if (!disabled) {
      setState((prevState) => {
        return { ...prevState, displayHover: false, displayActive: true };
      });
      if (onClick) {
        onClick(e);
      }
    }
  };

  const onBlurWrapper = () => {
    if (!disabled) {
      setState((prevState) => {
        return {
          ...prevState,
          displayHover: false,
          displayActive: false,
          displayFocused: false,
        };
      });
      if (onBlur) {
        onBlur();
      }
    }
  };

  const onKeyUpWrapper = (e) => {
    if (!disabled) {
      if (e.keyCode === 9) {
        onMouseOverWrapper();
        setState((prevState) => {
          return { ...prevState, displayFocused: true };
        });
      }
      if (onKeyUp) {
        onKeyUp(e);
      }
    }
  };

  const onKeyDownWrapper = (e) => {
    if (!disabled) {
      if (e.keyCode === 13 || e.keyCode === 32) {
        e.preventDefault();
        onClickWrapper(e);
      }
      if (onKeyDown) {
        onKeyDown(e);
      }
    }
  };

  /* uses this package: https://www.npmjs.com/package/classnames to make conditional
    class names easier to manage. */
  const classList = classNames(
    "js-fds-primary-button fds-primary-button",
    classes.COLOR_SCHEME,
    { [classes.OUTLINED]: outlined },
    { [classes.FOCUSED]: state.displayFocused },
    { [classes.ACTIVE]: state.displayActive },
    { [classes.HOVER]: state.displayHover },
    { [classes.DISABLED]: disabled },

    { className: className }
  );
  return (
    <div className={classList} {...rest}>
      <button
        type="button"
        className="fds-primary-button__button"
        onClick={onClickWrapper}
        onMouseOver={onMouseOverWrapper}
        onMouseOut={onMouseOutWrapper}
        onBlur={onBlurWrapper}
        onKeyUp={onKeyUpWrapper}
        onKeyDown={onKeyDownWrapper}
        {...buttonProps}
        disabled={disabled}
        data-testid={`${dataTestId}Button`}
      >
        {children}
      </button>
    </div>
  );
};

export default ReactPrimaryButton;
